import type { CatalogService, Supplier } from '@/mock/types'
import { DetailSheet } from '@/patterns/dialog'
import { ProfilePane } from './profile-pane'
import { SupplierStatus } from './supplier-status'

/**
 * A catalog supplier's detail: the same public profile as on the left of the
 * supplier sheet, read-only. The footer adds them to Moji dodavatelé, or, if
 * they're already there, shows their status and opens them.
 */
export function CatalogSheet({
  item,
  existing,
  canAdd,
  onAdd,
  onOpenMine,
  onClose,
}: {
  item: CatalogService
  existing?: Supplier
  canAdd: boolean
  onAdd: () => void
  onOpenMine: (supplierId: string) => void
  onClose: () => void
}) {
  return (
    <DetailSheet
      open
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
      width="wide"
      eyebrow="Katalog"
      title={item.name}
      titleContent={<span />}
      footerAccessory={
        existing ? (
          <span className="flex items-center gap-2 text-sm text-muted-foreground">
            U vás <SupplierStatus status={existing.status} />
          </span>
        ) : null
      }
      primaryAction={
        existing
          ? { label: 'Otevřít v Mých dodavatelích', onClick: () => onOpenMine(existing.id) }
          : canAdd
            ? { label: 'Přidat mezi moje dodavatele', onClick: onAdd }
            : undefined
      }
    >
      <div className="-mx-6 -my-5">
        <ProfilePane
          name={item.name}
          category={item.category}
          catalog={{ id: item.id, region: item.region }}
          profile={{ description: item.description, website: item.website, ...item.profile }}
          editable={false}
          onChange={() => {}}
          onNameChange={() => {}}
          inCatalog
        />
      </div>
    </DetailSheet>
  )
}
